import { EventEmitterType } from '../enums/event-service-type.enum';

export interface EventEmitterEvent {
  type: EventEmitterType;
  data: any;
}
